var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect } from "react";
import Typography from "../Typography";
import classnames from "classnames";
import PropTypes from "prop-types";
import _uniqueId from "lodash/uniqueId";
export var Checkbox = function (_a) {
    var _b;
    var label = _a.label, onChange = _a.onChange, _c = _a.checked, checked = _c === void 0 ? false : _c, _d = _a.labelPlacement, labelPlacement = _d === void 0 ? "left" : _d, _e = _a.className, className = _e === void 0 ? "" : _e, _f = _a.indeterminate, indeterminate = _f === void 0 ? false : _f, _g = _a.prefixCls, prefixCls = _g === void 0 ? "mex-checkbox" : _g, otherProps = __rest(_a, ["label", "onChange", "checked", "labelPlacement", "className", "indeterminate", "prefixCls"]);
    var _h = useState(checked), isChecked = _h[0], setChecked = _h[1];
    var _j = useState(null), inputRefState = _j[0], setInputRefState = _j[1];
    var setInputRef = function (input) {
        if (input && !isChecked) {
            input.indeterminate = indeterminate;
        }
        setInputRefState(input);
    };
    useEffect(function () {
        if (inputRefState)
            inputRefState.indeterminate = indeterminate;
        setChecked(checked);
    }, [checked, indeterminate]);
    var handleChange = function (e) {
        setChecked(!isChecked);
        if (onChange) {
            onChange(e);
        }
    };
    var classNames = classnames((_b = {},
        _b["".concat(prefixCls, "__input")] = true,
        _b[className] = className,
        _b));
    var uid = useState(_uniqueId("".concat(prefixCls, "-id-")))[0];
    var id = otherProps.id || uid;
    var handleOnClick = function () {
        inputRefState === null || inputRefState === void 0 ? void 0 : inputRefState.click();
    };
    return (_jsx(React.Fragment, { children: _jsx("div", __assign({ className: "".concat(prefixCls, "__wrapper") }, { children: _jsxs("div", __assign({ className: classNames }, { children: [label && labelPlacement === "left" && (_jsx(Typography, __assign({ variant: "body02Regular", onClick: handleOnClick, className: "".concat(prefixCls, "__label--left") }, { children: label }))), _jsx("input", __assign({}, otherProps, { type: otherProps.type ? otherProps.type : "checkbox", onChange: handleChange, id: id, checked: isChecked, ref: setInputRef })), _jsx("label", __assign({ htmlFor: id }, { children: prefixCls === "mex-switch" && _jsx("span", {}) })), label && labelPlacement === "right" && (_jsx(Typography, __assign({ variant: "body02Regular", className: "".concat(prefixCls, "__label--right"), onClick: handleOnClick }, { children: label })))] })) })) }));
};
Checkbox.propTypes = {
    label: PropTypes.string,
    labelPlacement: PropTypes.oneOf(["left", "right"]),
    checked: PropTypes.bool,
    onChange: PropTypes.func,
    className: PropTypes.string,
    indeterminate: PropTypes.bool,
};
Checkbox.defaultProps = {
    labelPlacement: "left",
};
export default Checkbox;
